import type { BinGroup, ExtendedBin } from "./types";
import { useSelector } from "@legendapp/state/react";
import { useRef } from "react";
import { DoubleSide, InstancedMesh, Vector3 } from "three";
import { Instance, Instances } from "@react-three/drei";
import { Observable } from "@legendapp/state";
import { calcBoxCenter } from "./utils";

const ZERO_SCALE = new Vector3(0, 0, 0);
const NORMAL_SCALE = new Vector3(1, 1, 1);

export function BinGroup({
  binGroup,
  selected$,
  hovered$,
}: {
  binGroup: BinGroup;
  index: number;
  hovered$: Observable<number | null>;
  selected$: Observable<ExtendedBin | null>;
}) {
  const mesh = useRef<InstancedMesh | null>(null);

  const selected = useSelector(() => selected$.get());
  const hovered = useSelector(() => hovered$.get());

  return (
    <>
      <Instances
        ref={mesh as any}
        range={binGroup.bins.length}
        limit={binGroup.bins.length}
      >
        <boxGeometry args={[...binGroup.dimensions]}></boxGeometry>
        <meshBasicMaterial
          side={DoubleSide}
          transparent
          depthTest
          depthWrite={false}
          opacity={0.2}
          polygonOffset
          polygonOffsetFactor={-4}
        />
        {binGroup.bins.map((bin) => {
          return (
            <Instance
              key={bin.id}
              scale={selected?.id === bin.id ? ZERO_SCALE : NORMAL_SCALE}
              color={hovered === bin.id ? "#1847ad" : "#2563eb"}
              onPointerOver={(e) => {
                e.stopPropagation();

                if (!mesh.current || e.instanceId === undefined) return;

                hovered$.set(bin.id);
              }}
              onPointerOut={(e) => {
                e.stopPropagation();

                if (!mesh.current || e.instanceId === undefined) return;
                hovered$.set(null);
              }}
              onClick={(e) => {
                e.stopPropagation();
                if (!mesh.current || e.instanceId === undefined) return;

                selected$.set(
                  selected?.id === bin.id
                    ? null
                    : {
                        ...bin,
                        dimensions: binGroup.dimensions,
                      }
                );
              }}
              position={calcBoxCenter(bin.x, bin.y, bin.z)}
            />
          );
        })}
      </Instances>
    </>
  );
}
